/* eslint-disable promise/param-names */
import * as types from '../types.js'

const state = {
    user: JSON.parse(localStorage.getItem('user')) || null,
    status: '',
    hasLoadedOnce: false
}

const getters = {
    isAuthenticated: state => !!state.user,
    authStatus: state => state.status,
    hasRole: state => role => {
        if(!state.user){
            return false
        }
        if(state.user.roles.indexOf('admin') >= 0){
            return true
        }
        else if(state.user.roles.indexOf(role) >= 0){
            return true
        }
        return false
    }
}

const actions = {
    [types.AUTH_REQUEST]: ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => {
            commit(types.AUTH_REQUEST)
            const formData = new FormData();
            formData.set('email', user.username);
            formData.set('password', user.password);
            formData.set('remember', user.remember);

            axios.post(
                    '/login',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Accept': 'application/json'
                        },
                        withCredentials: true
                    }
                )
                .then(resp => {
                    commit(types.AUTH_SUCCESS, resp)
                    resolve(resp)
                })
                .catch(err => {
                    commit(types.AUTH_ERROR, err)
                    localStorage.removeItem('api-token')
                    reject(err)
                })
        })
    },
    [types.AUTH_LOGOUT]: ({commit}) => {
        return axios.post('/logout')
            .then(resp => {
                commit(types.AUTH_LOGOUT)
                return resp
            })
    }
}

const mutations = {
    [types.AUTH_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [types.AUTH_SUCCESS]: (state, resp) => {
        localStorage.setItem('user', JSON.stringify(resp.data.user))
        axios.defaults.headers.common['Authorization'] = 'Bearer '+resp.data.api_token
        state.user = resp.data.user
        state.status = 'success'
        state.token = resp.data.api_token
        state.hasLoadedOnce = true
    },
    [types.AUTH_ERROR]: (state) => {
        state.status = 'error'
        state.hasLoadedOnce = true
    },
    [types.AUTH_LOGOUT]: (state) => {
        localStorage.removeItem('user')
        state.user = null
        state.token = ''
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}